export enum BankAccountStatus {
    None = 0,
    Pending = 1,
    Validated = 2,
    Sent = 3,
    Verified = 4,
    FailedInvalid = 5,
    FailedWrongHolder = 6,
    FailedInactive = 7,
    FailedDebitNotAllowed = 8
}

export const BankAccountStatusDescriptionsShort = {
    [BankAccountStatus.None]: "None",
    [BankAccountStatus.Pending]: "Pending",
    [BankAccountStatus.Validated]: "Validated",
    [BankAccountStatus.Sent]: "Verification Sent",
    [BankAccountStatus.Verified]: "Verified",
    [BankAccountStatus.FailedInvalid]: "Failed",
    [BankAccountStatus.FailedWrongHolder]: "Failed",
    [BankAccountStatus.FailedInactive]: "Failed",
    [BankAccountStatus.FailedDebitNotAllowed]: "Failed"
};

export const BankAccountStatusDescriptions = {
    [BankAccountStatus.None]: "No status set",
    [BankAccountStatus.Pending]: "Verification pending",
    [BankAccountStatus.Validated]: "Verification outstanding",
    [BankAccountStatus.Sent]: "Valid - Sent for Verification",
    [BankAccountStatus.Verified]: "Account Verified with Bank",
    [BankAccountStatus.FailedInvalid]: "Failed Validation",
    [BankAccountStatus.FailedWrongHolder]: "Failed Identity Mismatch",
    [BankAccountStatus.FailedInactive]: "Failed Inactive Account",
    [BankAccountStatus.FailedDebitNotAllowed]: "Failed Debits Not Allowed"
};

export enum BankAccountType {
    None = 0,
    Current = 1,
    Savings = 2,

    // Transmission = 3,
    // Bond = 4,
    // Subscription = 5
}

/**
 * C# flags enum.
 * @see https://docs.microsoft.com/en-us/dotnet/csharp/language-reference/builtin-types/enum#flags-attribute
 * @example ```txt
 * Can be 4 + 2 + 1 = 7 to represent all three values.
 * ```
 */
export enum CustomerType {
    None = 0,
    Patient = 1, // Patient.
    Debtor = 2, // Customer.
    Authorizer = 4, // Account holder.

    // Filled in to represent all three values as TypeScript does not support flags enums.
    PatientAndDebtor = 3,
    PatientAndAuthorizer = 5,
    DebtorAndAuthorizer = 6,
    PatientDebtorAndAuthorizer = 7
}


export enum Title {
    None = 0,
    Mr = 1,
    Mrs = 2,
    Miss = 3,
    Master = 4,
    Prof = 5,
    Dr = 6,
    Ds = 7,
    Rabbi = 8,
    TheHon = 9,
    Ms = 10,
    Rev = 11,
    Sgt = 12,
    Sister = 13
}

export const TitleDescriptions = {
    [Title.None]: "Unknown",
    [Title.Mr]: "",
    [Title.Mrs]: "",
    [Title.Miss]: "",
    [Title.Master]: "",
    [Title.Prof]: "Professor",
    [Title.Dr]: "",
    [Title.Ds]: "",
    [Title.Rabbi]: "",
    [Title.TheHon]: "The Honourable",
    [Title.Ms]: "",
    [Title.Rev]: "Reverend",
    [Title.Sgt]: "Sargent",
    [Title.Sister]: ""
};

export enum PayCycle {
    Monthly = 7,
    Weekly = 5,
    Fortnightly = 6
}

export enum MaritalStatus {
    Unknown = 0,
    Single = 1,
    Married = 2,
    Divorced = 3,
}

export enum TaskRequestType {
    cancellation_request = 5,
    customer_request_update_details = 23,
    change_bank_details = 9,
    customer_request_amend_loan_amount = 24,
    change_of_debit_order_date = 8,
    customer_request_change_debit_order_amount = 25,
    special_debit_order_request = 6,
    customer_request_change_start_date = 26,
    customer_request_general_queries = 27,
    vendor_request_general_queries = 28,
    vendor_request_update_company_details = 29,
}

export const TaskRequestTypeDescriptions = {
    [TaskRequestType.cancellation_request]: "Request to cancel a loan.",
    [TaskRequestType.customer_request_update_details]: "Request to update personal details.",
    [TaskRequestType.change_bank_details]: "Request to change bank details.",
    [TaskRequestType.customer_request_amend_loan_amount]: "Request to amend loan amount.",
    [TaskRequestType.change_of_debit_order_date]: "Request to change an instalment date.",
    [TaskRequestType.customer_request_change_debit_order_amount]: "Request to change an instalment amount.",
    [TaskRequestType.special_debit_order_request]: "Request to run a special debit order.",
    [TaskRequestType.customer_request_change_start_date]: "Request a different start date.",
    [TaskRequestType.customer_request_general_queries]: "General queries.",
    [TaskRequestType.vendor_request_general_queries]: "General queries.",
    [TaskRequestType.vendor_request_update_company_details]: "Update company details: Name, Trading Name, Registration Number, Telephone, etc.",
};

export enum ActivityStatus {
    None = 0,
    Unassigned = 1,
    Assigned = 2,
    InProgress = 3,
    Completed = 4,
    Canceled = 5,
    Waiting = 6,
    Stopped = 99
}

export enum Sex {
    None = 0,
    Male = 1,
    Female = 2,
}

export const SexDescriptions = {
    [Sex.None]: 'Unknown',
    [Sex.Male]: 'Male',
    [Sex.Female]: 'Female',
};

export enum IdentificationType {
    RSAID = 1,
    Passport = 4,
    Other = 3
}


export enum ApplicationStatus {
    Inactive = 1,
    PreApproved = 2,
    Active = 3,
    Declined = 4,
    Cancelled = 5,
    Legal = 6,
    Deceased = 7,
    Administration = 8,
    Closed = 9,
}

export const ApplicationStatusDescriptionShort = {
    [ApplicationStatus.Inactive]: "Inactive",
    [ApplicationStatus.PreApproved]: "Pre-Approved",
    [ApplicationStatus.Active]: "Active",
    [ApplicationStatus.Declined]: "Declined",
    [ApplicationStatus.Cancelled]: "Cancelled",
    [ApplicationStatus.Legal]: "Legal",
    [ApplicationStatus.Deceased]: "Deceased",
    [ApplicationStatus.Administration]: "Administration",
    [ApplicationStatus.Closed]: "Closed",
}

export const ApplicationStatusDescription = {
    [ApplicationStatus.Inactive]: "The product application has been captured but not released.",
    [ApplicationStatus.PreApproved]: "The product application requires a pre-payment before being accepted.",
    [ApplicationStatus.Active]: "This status refers to a debtor who is in good standing and paying normally.",
    [ApplicationStatus.Declined]: "We are unhappy with the product application and decline it.",
    [ApplicationStatus.Cancelled]: "The customer backs out of the product application and we cancel it.",
    [ApplicationStatus.Legal]: "The customer has been handed over to an attorney or debt collection agency.",
    [ApplicationStatus.Deceased]: "Customer has passed away. Written off to bad debts ledger.",
    [ApplicationStatus.Administration]: "Customer has been placed under administration. Written off to bad debts ledger.",
    [ApplicationStatus.Closed]: "Product is paid up. No further transactions."
}

/**
 * Used for download and emailing of documents.
 */
export enum DocumentTypeEnum {
    None = 0,
    LoanAgreement = 1,          // VendorApplication API
    PatientAgreement = 2,       // VendorApplication API
    Statement = 3,              // VendorApplication API
    StaffForm = 4,              // Vendor API
    PayoutReport = 5,           // Vendor API
    Quotation = 6,              // VendorApplication API
    SigningDocuments = 7,       // VendorApplication API
    LoanAmendment = 9,          // VendorApplication API
    CustomerInformation = 10,   // Vendor API
}

export enum TableDatumType {
    VendorApplication = 1,
    CustomerProduct = 2,
    VendorLedger = 3,
    Other = 4,              // TODO this is because the table must be made generic...
    BookingRequest = 5,     // TODO this is because the table must be made generic...
}

export enum LoanStartDateOptions {
    ThisMonth = 1,
    NextMonth = 2,
    TwoMonths = 3,
    ThreeMonths = 4,
}

export enum SigningMethod {
    None = 0,
    Electronic = 1,
    Manual = 2,
}

export enum BookingRequestType {
    BookingRequest = 1,
    GeneralEnquiry = 2,
}

export enum BookingRequestStatus {
    None = 0,
    Captured = 1,       // from WP site
    Assigned = 2,       // by TJ to a vendor, so will include vendor id
    Viewed = 3,         // vendor has viewed the request
    Booked = 4,         // vendor has booked the appointment
    Completed = 5,      // appointment completed
    Cancelled = 6,      // cancelled by vendor or customer
    Rejected = 99       // rejected by SpecsFin.
}

export const BookingRequestStatusDescription = {
    [BookingRequestStatus.None]: "None",
    [BookingRequestStatus.Captured]: "Captured",
    [BookingRequestStatus.Assigned]: "Requested",
    [BookingRequestStatus.Viewed]: "Requested",
    [BookingRequestStatus.Booked]: "Booked",
    [BookingRequestStatus.Completed]: "Completed",
    [BookingRequestStatus.Cancelled]: "Cancelled",
    [BookingRequestStatus.Rejected]: "Rejected",
};

export const BookingRequestTypeDescriptions = {
    [BookingRequestType.BookingRequest]: "Booking Request",
    [BookingRequestType.GeneralEnquiry]: "General Enquiry",
};